/**
 * Logo Slider Module
 * Adds optional slider functionality to logo-list sections using Flickity
 */

export class LogoSlider {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.logoBar = container.querySelector('.logo-bar');
    this.enableSlider = container.dataset.enableSlider === 'true';
    this.autoplay = container.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 3000;
    this.slidesToShow = parseInt(container.dataset.slidesToShow) || 4;
    this.flickity = null;

    if (!this.logoBar) {
      console.warn('[Logo Slider] Logo bar not found in container');
      return;
    }

    this.init();
  }

  init() {
    if (this.enableSlider) {
      this.initSlider();
    }
  }

  initSlider() {
    // Check if theme.Slideshow is available (Flickity wrapper)
    if (typeof theme === 'undefined' || typeof theme.Slideshow === 'undefined') {
      console.error('[Logo Slider] theme.Slideshow not available. Make sure theme.js is loaded.');
      return;
    }

    // Prepare logo bar for slider mode
    this.logoBar.classList.add('logo-bar--slider');

    // Flickity options - show multiple logos, scroll one at a time
    const flickityOptions = {
      cellAlign: 'left',
      contain: true,
      wrapAround: true, // Enable loop
      autoPlay: this.autoplay ? this.autoplaySpeed : false,
      prevNextButtons: true,
      pageDots: false,
      adaptiveHeight: false,
      setGallerySize: true,
      imagesLoaded: true,
      percentPosition: true,
      dragThreshold: 10,
      friction: 0.8,
      selectedAttraction: 0.14,
      pauseAutoPlayOnHover: true,
      groupCells: false // Don't group - scroll one cell at a time
    };

    try {
      // Initialize Flickity via theme.Slideshow
      this.flickity = new theme.Slideshow(this.logoBar, flickityOptions);

      console.log('[Logo Slider] Initialized successfully');
    } catch (error) {
      console.error('[Logo Slider] Failed to initialize:', error);
    }
  }

  destroy() {
    if (this.flickity && typeof this.flickity.destroy === 'function') {
      this.flickity.destroy();
      this.flickity = null;
    }

    if (this.logoBar) {
      this.logoBar.classList.remove('logo-bar--slider');
    }
  }
}

/**
 * Auto-initialize logo slider sections
 */
export function initLogoSlider() {
  const sections = document.querySelectorAll('[data-section-type="logo-list"]');

  sections.forEach(section => {
    // Only initialize if slider is enabled
    if (section.dataset.enableSlider === 'true') {
      new LogoSlider(section);
    }
  });
}

// Auto-init on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLogoSlider);
} else {
  initLogoSlider();
}

// Re-init on Shopify section load (theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="logo-list"]');
    if (section && section.dataset.enableSlider === 'true') {
      new LogoSlider(section);
    }
  });
}

